import type {
    CadastrarAutorizacaoAcaoCommand,
    CancelarAutorizacaoAcaoCommand, VerificarCodigoAutorizacaoCommand
} from "@/domain/commands/autorizacao.commands";
import {useRequestHelper} from "@/helpers/request.helper";
import type {ListarAutorizacaoAcaoQuery} from "@/domain/queries/autorizacao.query";
import type {AutorizacaoAcaoVm, ResultadoCodigoAutorizacao} from "@/domain/type/autorizacao.type";

const {sendRequestPost} = useRequestHelper();

class AutorizacaoAcaoService {

    cadastrar(command: CadastrarAutorizacaoAcaoCommand) {
        return sendRequestPost<string>("autorizacao/cadastrar", command);
    }

    cancelar(command: CancelarAutorizacaoAcaoCommand) {
        return sendRequestPost<string>("autorizacao/cancelar", command);
    }

    listar(query: ListarAutorizacaoAcaoQuery) {
        return sendRequestPost<AutorizacaoAcaoVm[]>("autorizacao/listar", query);
    }

    verificarCodigo(command: VerificarCodigoAutorizacaoCommand){
        return sendRequestPost<ResultadoCodigoAutorizacao>("autorizacao/verificarCodigo", command);
    }

}

export default new AutorizacaoAcaoService();